import React from "react";
import { NavLink } from "react-router-dom";
import bannerDesktop from "../../assets/images/appImages/Banner3.png";
import bannerMobile from "../../assets/images/appImages/Banniere-mobile.png";

function BannerPure() {
  return (
    <section
      className="section-banner-homepage banner-pure-essence"
      aria-label="Pure Essence Botanicals"
    >
      <img
        src={bannerMobile}
        alt=""
        className="banner-pure-essence__bg banner-pure-essence__bg--mobile"
        decoding="async"
        fetchPriority="high"
        width={440}
        height={338}
        aria-hidden="true"
      />
      <img
        src={bannerDesktop}
        alt=""
        className="banner-pure-essence__bg banner-pure-essence__bg--desktop"
        decoding="async"
        width={1961}
        height={802}
        aria-hidden="true"
      />

      <div className="col-left-banner-accueil">
        <h2 className="title-home-page">
          Pure Essence <strong>Botanicals</strong>
        </h2>
        <p className="text-home-page-banner">
          Une chaîne complète, de la terre au produit fini
          en Passant par La revalorisation Des résidus.
        </p>
        <NavLink className="btn-home-page voirbnt" to="/produits">
          Voir nos produits
        </NavLink>
      </div>
    </section>
  );
}

export default BannerPure;
